export default "__VITE_PUBLIC_ASSET__71ad363b__"